
export const SERVER_HOST = process.env.REACT_APP_SERVER_HOST
export const SERVER_FILES = process.env.REACT_APP_SERVER_FILES
export const SERVER_ENCRYPT_KEY = process.env.REACT_APP_SERVER_ENCRYPT_KEY

//EXPORT
export const Api = SERVER_HOST
